import { STATE_ABBREVIATIONS } from './State';

export const NO_JURISDICTION = 'NI' as const;
export const ALL_PERMIT_TYPE_JURISDICTION_CODES: string[] = [
  ...STATE_ABBREVIATIONS,
  NO_JURISDICTION,
].sort();
